import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Timer from "./DynamicRouting/components/Timer";
import { Optimization_Timer_Label } from "./DynamicRouting/constants";
import FeedbackSummaryHeader from "./DynamicRouting/components/FeedbackSummaryHeader";
import FeedbackRoutesSummary from "./DynamicRouting/components/FeedbackRoutesSummary";
import appConstants from "../../../appConstants";
import LastWaveSection from "./DynamicRouting/components/LastWaveSection";

const styles = (theme) => ({
  dialogRoot: {
    zIndex: 1200
  },
  dialogContainer: {
    paddingBottom: 16,
    userSelect: "none",
    backgroundColor: theme.ModalBGColor,
    minWidth: 800,
    height: "95vh",
    maxHeight: 700,
    minHeight: 500
  },
  dialogTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.HeaderSelectedText,
    paddingBottom: 8
  },
  dialogContent: {
    color: theme.gridTextColor,
    fontSize: 12,
    fontWeight: 600,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 12
  },
  closeIconStyle: {
    padding: "0px",
    float: "right",
    color: theme.gridTextColor,
    "&:hover": {
      backgroundColor: theme.ModalBGColor,
      color: theme.HeaderSelectedText
    }
  },
  closeIcon: {
    fontSize: 24
  },
  verticalDivider: {
    width: 1,
    backgroundColor: theme.TextColor
  },
  actionContainer: {
    width: '60%',
    margin: 0
  },
  dialogActionStyle: {
    padding: '0px 24px',
    margin: 0
  },
  dialogButtonStyle: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    float: "right",
    width: "35%"
  },
  textOverflow: {
    maxWidth: 600,
  },
  runTimeContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: 8
  }
});

const DynamicRoutingFeedback = (props) => {
  const { classes, show, onClose, dynamicRoutingOutputData, optimizationRunTimeDetails , themeName} = props;
  return (
    <Dialog
      open={show}
      onClose={onClose}
      classes={{ paper: classes.dialogContainer, root: classes.dialogRoot }}
      className={themeName}
      aria-labelledby="dynamic-routing-feedback"
    >
      <DialogTitle classes={{ root: classes.dialogTitle }} disableTypography>
        Dynamic Routing Completed Successfully
        <IconButton
          aria-label="Close"
          classes={{ root: classes.closeIconStyle }}
          onClick={onClose}
        >
          <CloseIcon classes={{ root: classes.closeIcon }} />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }} className="customScroll">
        <div className={classes.runTimeContainer}>
          <Timer
            label={Optimization_Timer_Label.queuedLabel}
            timeInSeconds={optimizationRunTimeDetails.queuedTime}
            useNormalStyle
          />
          <div className={classes.verticalDivider} />
          <Timer
            label={Optimization_Timer_Label.runTimeLabel}
            timeInSeconds={optimizationRunTimeDetails.runTime}
            useNormalStyle
          />
        </div>
        <FeedbackSummaryHeader data={dynamicRoutingOutputData} />
        <FeedbackRoutesSummary
          icon={appConstants.routeLockStates.UNLOCK.icon}
          label="City Routes"
          data={dynamicRoutingOutputData?.cityRoutes ?? []}
        />
        <FeedbackRoutesSummary
          icon={appConstants.routeLockStates.LOCK.icon}
          label="Other Routes"
          data={dynamicRoutingOutputData?.otherRoutes ?? {}}
          isExtraRoute
        />
        <LastWaveSection data={dynamicRoutingOutputData?.otherRoutes ?? {}} />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActionStyle }}>
        <div className={classes.actionContainer}>
          <Button
            variant="contained"
            onClick={onClose}
            color="primary"
            size="medium"
            classes={{
              root: classes.dialogButtonStyle
            }}
          >
            Done
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(DynamicRoutingFeedback);
